module.exports = __webpack_public_path__ + "static/img/app4.c45d6c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/app4.jpg
// module id = tNTF
// module chunks = 0